import apiClient from "./api";
const AREA_API_BASE_URL = "/areas";
class AreasService {
  getAreas() {
    return apiClient.get(AREA_API_BASE_URL);
  }
  agregarArea(area) {
    return apiClient.post(AREA_API_BASE_URL, area);
  }
  updateArea(area, areaId) {
    return apiClient.put(AREA_API_BASE_URL + "/" + areaId, area);
  }
  deleteArea(areaId) {
    return apiClient.delete(AREA_API_BASE_URL + "/" + areaId);
  }
}
export default new AreasService();